"use client";

/** GSAP-like tokens → cubic-bezier */
export function mapEase(ease?: string): string {
  const e = (ease || "").toLowerCase();
  const table: Record<string, string> = {
    "power1.out": "cubic-bezier(0.11, 0, 0.5, 0)",
    "power2.out": "cubic-bezier(0.11, 0, 0.5, 0)",
    "power3.out": "cubic-bezier(0.16, 1, 0.3, 1)",
    "power4.out": "cubic-bezier(0.16, 1, 0.3, 1)",
    "expo.out": "cubic-bezier(0.16, 1, 0.3, 1)",
    "circ.out": "cubic-bezier(0, 0.55, 0.45, 1)",
    "sine.out": "cubic-bezier(0.39, 0.575, 0.565, 1)",
    "back.out": "cubic-bezier(0.34, 1.56, 0.64, 1)",
    "ease-out": "ease-out",
    "ease-in-out": "ease-in-out",
    linear: "linear",
  };
  return table[e] || "cubic-bezier(0.16, 1, 0.3, 1)";
}

export function fromTransformOf(dir:
  "bottom" | "top" | "left" | "right" | "scale" | "fade"
) {
  switch (dir) {
    case "bottom":
      return "translate3d(0, 24px, 0)";
    case "top":
      return "translate3d(0, -24px, 0)";
    case "left":
      return "translate3d(-24px, 0, 0)";
    case "right":
      return "translate3d(24px, 0, 0)";
    case "scale":
      return "scale(0.96)";
    default:
      return "none"; // fade
  }
}
